const normalizeText = (value) => String(value || "").trim().replace(/\s+/g, " ");

const getGenericVehicleSequence = (vehicle) => {
  const storedSequence = Number(vehicle?.generated_name_sequence);
  if (Number.isSafeInteger(storedSequence) && storedSequence > 0) {
    return storedSequence;
  }

  if (vehicle?.vehicle_model !== "Generic Model") return null;

  const subtype = normalizeText(vehicle.vehicle_subtype);
  const name = normalizeText(vehicle.vehicle_name);
  if (!subtype || !name) return null;

  const base = `Generic Loader ${subtype}`;
  if (name.localeCompare(base, undefined, { sensitivity: "base" }) === 0) {
    return 1;
  }

  const prefix = `${base}-`;
  if (name.slice(0, prefix.length).localeCompare(prefix, undefined, { sensitivity: "base" }) !== 0) {
    return null;
  }

  const suffix = name.slice(prefix.length);
  if (!/^\d+$/.test(suffix)) return null;

  const parsedSequence = Number(suffix);
  return Number.isSafeInteger(parsedSequence) && parsedSequence > 0
    ? parsedSequence
    : null;
};

const sortVehiclesForDisplay = (vehicles = []) => (
  vehicles
    .map((vehicle, originalIndex) => ({
      vehicle,
      originalIndex,
      subtype: normalizeText(vehicle?.vehicle_subtype).toLocaleLowerCase(),
      genericSequence: getGenericVehicleSequence(vehicle),
    }))
    .sort((left, right) => {
      const subtypeComparison = left.subtype.localeCompare(right.subtype, undefined, {
        sensitivity: "base",
      });
      if (subtypeComparison !== 0) return subtypeComparison;

      const leftIsGeneric = left.genericSequence !== null;
      const rightIsGeneric = right.genericSequence !== null;
      if (leftIsGeneric !== rightIsGeneric) return leftIsGeneric ? 1 : -1;

      if (leftIsGeneric && left.genericSequence !== right.genericSequence) {
        return left.genericSequence - right.genericSequence;
      }

      const nameComparison = normalizeText(left.vehicle?.vehicle_name).localeCompare(
        normalizeText(right.vehicle?.vehicle_name),
        undefined,
        { sensitivity: "base" },
      );
      if (nameComparison !== 0) return nameComparison;

      return left.originalIndex - right.originalIndex;
    })
    .map(({ vehicle }) => vehicle)
);

export { getGenericVehicleSequence, sortVehiclesForDisplay };
